// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__20Tnl","errorLogs":"EditorFooter_errorLogs__1Sp1W"};